// components/CookieConsent.js
import React, { useEffect, useState } from "react";
import { setCookie, getCookie } from "../utils/cookie";
import "./CookieConsent.css";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getCookie("cookie_consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    setCookie("cookie_consent", "true", 365);
    setVisible(false);
  };
  const declineCookies = () => {
    setCookie("cookie_consent", "false", 365);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        当社は、お客様の体験を向上させるためにクッキーを使用します。このサイトを引き続き訪問することにより、お客様は当社のクッキーの使用に同意したことになります。
      </p>
      <div className="cookie-buttons">
        <button onClick={declineCookies} className="decline-btn">拒否</button>
        <button onClick={acceptCookies} className="accept-btn">承認 </button>
      </div>
    </div>
  );
};

export default CookieConsent;
